// TODO LOAD CONFIG FROM EXTERNAL
mapboxgl.accessToken =
  "pk.eyJ1IjoiamVyZW15LXA4MHciLCJhIjoiY2tnbGVuZnk5MDI5eDMwam9jYjUwMDdtOSJ9.fUpy-fwtbeueKExg-G4UMw";

var easingFunctions = {
  // start slow and gradually increase speed
  easeInCubic: function (t) {
    return t * t * t;
  },
  // start fast with a long, slow wind-down
  easeOutQuint: function (t) {
    return 1 - Math.pow(1 - t, 5);
  },
  // slow start and finish with fast middle
  easeInOutCirc: function (t) {
    return t < 0.5
      ? (1 - Math.sqrt(1 - Math.pow(2 * t, 2))) / 2
      : (Math.sqrt(1 - Math.pow(-2 * t + 2, 2)) + 1) / 2;
  },
  // fast start with a "bounce" at the end
  easeOutBounce: function (t) {
    var n1 = 7.5625;
    var d1 = 2.75;

    if (t < 1 / d1) {
      return n1 * t * t;
    } else if (t < 2 / d1) {
      return n1 * (t -= 1.5 / d1) * t + 0.75;
    } else if (t < 2.5 / d1) {
      return n1 * (t -= 2.25 / d1) * t + 0.9375;
    } else {
      return n1 * (t -= 2.625 / d1) * t + 0.984375;
    }
  }
};

var animationOptions = {
  duration: 1000,
  easing: easingFunctions.easeInCubic,
  offset: [0, 0],
  animate: true,
  essential: true,
  zoom: 10
};

const stores = Object.freeze(locationData);
let zoomLevel = 10;

//Homepage does not produce a page.id
if (theme.pageId == "") {
 zoomLevel = 10.75;
}

var map = new mapboxgl.Map({
  container: "mapboxgl-container",
  style: "mapbox://styles/mapbox/light-v10",
  center: [-73.952205, 40.764834],
  zoom: zoomLevel,
  scrollZoom: false,
});

function addMarkers(features) {
  let markers = [];

  // the plotted map points are 'features'
  features.forEach(function (marker, index) {
    var el = document.createElement("div");
    el.className = "marker";

    // add it to the mapbox DOM
    new mapboxgl.Marker(el, {offset: [0, -43]}).setLngLat(marker.geometry.coordinates).addTo(map);

    // trigger flyout onclick
    el.addEventListener("click", function (e) {
      let clickedMarker = e.currentTarget;

      // TODO better method to keep track of state...
      if(!clickedMarker.classList.contains("marker-selected")){
	// reset the selected marker
	$(".marker-selected").removeClass("marker-selected");
	$(clickedMarker).addClass("marker-selected");

	// for user-convenience
	flyToStore(marker);
	// create handles removing any preexisting flyout
	displayFlyout(marker);
      }      
    });

    markers.push(el);
  });

  return markers;
}

// collection datastore is located from the section template
map.on("load", function (e) {
  // add data to map as a layer
  map.addSource("places", {
    type: "geojson",
    data: stores,
  });

  var nav = new mapboxgl.NavigationControl();
  map.addControl(nav, "top-left");

  addMarkers(stores.features);
});

function flyToStore(currentFeature) {
  map.flyTo({
    center: currentFeature.geometry.coordinates,
    offset: [-150, 0],
    zoom: 15,
  });
}

function sanitizeMarkup(input) {
  var temp = document.createElement("div");
  temp.textContent = str;
  return temp.innerHTML;
}

function bindCloseFlyout(flyout) {
  flyout.querySelector(".map__close").addEventListener(
    "click",
    () => {
      $(".marker-selected").removeClass("marker-selected");
      $(flyout).fadeOut("fast");
      map.easeTo(animationOptions);
    },
    {once: true}
  );
}

function displayFlyout(currentFeature) {
  // TODO could save some computation by caching the popuplated flyout post-display for later use
  let overlay = document.getElementById("mapboxgl-flyout-overlay");

  bindCloseFlyout(overlay);

  // Check if there is already a flyout on the map and if so, remove it
  if (overlay.style.display === "none") {
    /* TODO encapsulate map in a class to separate from DOM
	     implement handlebars to fill flyout data
	     could be combined with displayFlyout as it will close the flyout when open (rename displayFlyout) */
    $(overlay).toggle("slide", {direction: "right"}, 1000);
  } else {
    // map is already shown - fade it out and then display with new data
    // TODO this could be handled recursively - hide the element, load the data, call self
    $(overlay).fadeOut("fast").toggle("slide", {direction: "right"}, 1000);
  }
  
  // TODO implement in handlebars
  let values = currentFeature.properties,
      destination = `${encodeURIComponent(values.address?.replaceAll(" ", "+"))}${encodeURIComponent(values?.cityState.replaceAll(" ", "+"))}`,
      gmapDirections = `https://www.google.com/maps/dir/?api=1&destination=${destination}`;

  $(overlay)
    .find("h3#site-title").html(values?.title).end()
    .find("#location-header-splash").css("background-image", `url("${values?.header}")`).end()
    .find("span#site-address-1").html(values?.address).end()
    .find("span#site-address-2").html(values?.addressExtended).end()
    .find("span#site-address-3").html(`${values?.cityState} ${values?.postalCode}`).end()
    .find("a#site-directions").attr("href", gmapDirections).end()
    .find("a#site-email").attr("href", `mailto:${values?.email}`).children("span.info").first().html(values?.email).closest(overlay)
    .find("a#site-phone-1").attr("href", `tel:${values?.phone}`).children("span.info").first().html(values?.phone).closest(overlay)
    .find("a#site-phone-2").attr("href", `tel:${values?.fax}`).children("span.info").first().html(values?.fax);

  // gross
  values?.addressExtended && $(overlay).find("span#site-address-2").show() || $(overlay).find("span#site-address-2").hide();
  values?.email && $(overlay).find("a#site-email").parent().show() || $(overlay).find("a#site-email").parent().hide();
  values?.fax && $(overlay).find("a#site-phone-2").parent().show() || $(overlay).find("a#site-phone-2").parent().hide();
  

  return this;
}
